import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, Form } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

import { auth } from './../../../utils/authToken';
import { connect } from './../../../utils/connect';
import * as styles from './LoginForm.less';

const LoginForm = props => {
  const from = _.get(props, 'from', '/');
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    auth.isAuthenticated('jwtToken', 'jwtUser')
      ? setIsAuthenticated(true)
      : setIsAuthenticated(false);
  }, []);

  const login = () => {
    connect.authenticate({ user, password }, () => setIsAuthenticated(true));
  };

  const signout = () => {
    connect.signout(() => setIsAuthenticated(false));
  };

  const handleClick = () => {
    signout();
  };

  const handleChange = event => {
    const { name } = event.target;

    switch (name) {
      case 'user':
        return setUser(event.target.value);
      case 'password':
        return setPassword(event.target.value);
      default:
        return;
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
    login();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Input
        name='user'
        placeholder='User'
        onChange={handleChange}
        value={user}
      />
      <Form.Input
        name='password'
        placeholder='Password'
        onChange={handleChange}
        type='password'
        value={password}
      />
      <Form.Button fluid secondary>
        Login
      </Form.Button>
    </Form>
  );
};

LoginForm.propTypes = {
  from: PropTypes.string,
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/views/components/LoginForm/LoginForm.js